import { HttpBackend, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { catchError, throwError } from 'rxjs';

import { ServerLoggerInterface, ServerRequestProperties } from './server-logger.interface';
import { LoggerConfig } from '../logger-config';
import { LoggerMetadata } from '../metadata/metadata';

@Injectable()
export class BaseServerLogger implements ServerLoggerInterface {
  private readonly httpBackend = inject(HttpBackend);

  public getRequestProperties(): ServerRequestProperties {
    return { url: '/log' };
  }

  public logToServer(metadata: LoggerMetadata): void {
    const requestBody = { ...metadata };
    requestBody.additional = this.secureAdditionalParameters(requestBody.additional || []);
    requestBody.message = this.secureMessage(requestBody.message);

    const requestProperties = this.getRequestProperties();

    const request = new HttpRequest<any>('POST', requestProperties.url, requestBody, {
      headers: requestProperties.headers,
      responseType: requestProperties.responseType
    });

    this.httpBackend
      .handle(request)
      .pipe(
        catchError((error) => {
          console.error('Failed to log on server', error);
          return throwError(() => error);
        })
      )
      .subscribe();
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public shouldCallServer(config: LoggerConfig, metadata: LoggerMetadata): boolean {
    return config.logToServer;
  }

  private secureAdditionalParameters(additional: any[]): any[] {
    return additional.map((next, idx) => {
      try {
        if (next instanceof Error && JSON.stringify(next) === '{}') {
          return next.stack || next.message;
        }

        // We don't need to actually stringify here, just make sure it won't error when trying.
        if (typeof next === 'object') {
          JSON.stringify(next);
        }

        return next;
      } catch (_) {
        return `The additional[${idx}] value could not be stringified`;
      }
    });
  }

  private secureMessage(message: any): string {
    try {
      if (message instanceof Error && JSON.stringify(message) === '{}') {
        message = message.stack || message.message;
      }

      if (typeof message !== 'string') {
        message = JSON.stringify(message, null, 2);
      }
    } catch {
      message = 'The provided message could not be stringified';
    }

    return message;
  }
}
